module.exports = __webpack_public_path__ + "static/media/UserDash.305721ff.png";